var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class SortableCheck {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get isSortableMatchingAnySuccessState() {
        let correctStateIndex = -1;
        for (let i = 0; i < this.question.sortableStore.successStates.length && correctStateIndex === -1; i++) {
            const successState = this.question.sortableStore.successStates[i];
            let isMatching = true;
            this.question.sortableStore.sortableItems.forEach((sortableItem) => {
                const found = successState.sortableItemStates.find((item) => item.sortableItemId === sortableItem.id_string &&
                    item.droppableId === sortableItem.droppableId &&
                    item.indexInDroppable === sortableItem.indexInDroppable);
                if (!found)
                    isMatching = false;
            });
            if (isMatching)
                correctStateIndex = i;
        }
        return correctStateIndex !== -1;
    }
    get numberOfItemsInAnyCorrectPlace() {
        return this.question.sortableStore.sortableItems.filter((i) => i.itemUI.isItemInAnyCorrectPlace).length;
    }
}
__decorate([
    computed
], SortableCheck.prototype, "isSortableMatchingAnySuccessState", null);
